export default __webpack_public_path__ + "static/media/video.0e68ca04.mp4";